import React, { useEffect, useState, ReactNode, useRef } from 'react';
import BundleContainer from '../../../../components/smart-modules/BundleContainer';
import { useCartContext } from '../../../../utils/cart/context/CartContext';
import { useShopifyProduct } from '../../../../api/shopify/ShopifyProduct';
import { styles } from './ProductBundle.css';
import { useSmartModuleContext } from '../SmartModuleProvider';

type ProductBundleProps = { children?: ReactNode };

const ProductBundle = ({ children }: ProductBundleProps): JSX.Element => {
  const { smartModulesData } = useSmartModuleContext();
  const { cart } = useCartContext();
  const { productMetafields } = useShopifyProduct();
  const container = useRef(null);
  const [isBundleEnabled, setIsBundleEnabled] = useState(!!window.Product);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const bundlesFound =
      smartModulesData?.productBundleAlgoliaData?.length && smartModulesData?.productBundleAlgoliaData?.length > 1;
    if (bundlesFound) {
      setIsBundleEnabled(bundlesFound && !!window.Product);
      setShowLoading(!bundlesFound);
    } else {
      setIsBundleEnabled(false);
    }
  }, [smartModulesData]);

  if (
    isBundleEnabled &&
    (smartModulesData.productBundleAlgoliaData?.length ?? 0) > 0 &&
    productMetafields.Availability.CanBuyOnline
  ) {
    return (
      <div className={`${styles.productBundle} ${!showLoading ? 'modules-loaded' : ''}`} ref={container}>
        <BundleContainer
          mainProductSku={window?.Product?.sku}
          products={smartModulesData.productBundleAlgoliaData}
          showPrice
          isLoading={showLoading}
          cartItems={cart?.items || []}
        />
      </div>
    );
  }
  return <>{children}</>;
};

export default ProductBundle;
